export const textVariants = {
  'dl-bold': {
    fontSize: '72px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '92.16px',
    letterSpacing: '-1.5px',
    textTransform: null,
  },
  'dl-semibold': {
    fontSize: '72px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '92.16px',
    letterSpacing: '-1.5px',
    textTransform: null,
  },
  'dl-regular': {
    fontSize: '72px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '92.16px',
    letterSpacing: '-1.5px',
    textTransform: null,
  },
  'ds-bold': {
    fontSize: '58px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '74.24px',
    letterSpacing: '-0.5px',
    textTransform: null,
  },
  'ds-semibold': {
    fontSize: '58px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '74.24px',
    letterSpacing: '-0.5px',
    textTransform: null,
  },
  'ds-regular': {
    fontSize: '58px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '74.24px',
    letterSpacing: '-0.5px',
    textTransform: null,
  },
  'h1-bold': {
    fontSize: '48px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '62px',
    letterSpacing: null,
    textTransform: null,
  },
  'h2-bold': {
    fontSize: '34px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '48px',
    letterSpacing: null,
    textTransform: null,
  },
  'h3-bold': {
    fontSize: '26px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '36px',
    letterSpacing: null,
    textTransform: null,
  },
  'h4-bold': {
    fontSize: '20px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '30px',
    letterSpacing: null,
    textTransform: null,
  },

  'h5-bold': {
    fontSize: '16px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '23px',
    letterSpacing: null,
    textTransform: null,
  },
  'h6-bold': {
    fontSize: '14px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '21px',
    letterSpacing: null,
    textTransform: null,
  },
  'h1-semibold': {
    fontSize: '48px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '62px',
    letterSpacing: null,
    textTransform: null,
  },
  'h2-semibold': {
    fontSize: '34px',
    fontStyle: null,
    fontWeight: '600',
    lineHeight: '42px',
    letterSpacing: null,
    textTransform: null,
  },
  'h3-semibold': {
    fontSize: '26px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '36px',
    letterSpacing: null,
    textTransform: null,
  },
  'h4-semibold': {
    fontSize: '20px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '30px',
    letterSpacing: null,
    textTransform: null,
  },
  'h5-semibold': {
    fontSize: '16px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '23px',
    letterSpacing: null,
    textTransform: null,
  },
  'h6-semibold': {
    fontSize: '14px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '21px',
    letterSpacing: null,
    textTransform: null,
  },
  'h1-regular': {
    fontSize: '48px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '62px',
    letterSpacing: null,
    textTransform: null,
  },
  'h2-regular': {
    fontSize: '34px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '48px',
    letterSpacing: null,
    textTransform: null,
  },
  'h3-regular': {
    fontSize: '26px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '36px',
    letterSpacing: null,
    textTransform: null,
  },
  'h4-regular': {
    fontSize: '20px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '30px',
    letterSpacing: null,
    textTransform: null,
  },
  'h5-regular': {
    fontSize: '16px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '23px',
    letterSpacing: null,
    textTransform: null,
  },
  'h6-regular': {
    fontSize: '14px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '21px',
    letterSpacing: null,
    textTransform: null,
  },
  'bl-bold': {
    fontSize: '18px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '27px',
    letterSpacing: '0.5px',
    textTransform: null,
  },
  'bl-semibold': {
    fontSize: '18px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '27px',
    letterSpacing: null,
    textTransform: null,
  },
  'bl-regular': {
    fontSize: '18px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '27px',
    letterSpacing: null,
    textTransform: null,
  },
  'bl-bold-italic': {
    fontSize: '18px',
    fontStyle: 'italic',
    fontWeight: '400',
    lineHeight: '27px',
    letterSpacing: null,
    textTransform: null,
  },
  'bm-bold': {
    fontSize: '16px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '22px',
    letterSpacing: null,
    textTransform: null,
  },
  'bm-semibold': {
    fontSize: '16px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '22px',
    letterSpacing: null,
    textTransform: null,
  },
  'bm-regular': {
    fontSize: '16px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '22px',
    letterSpacing: null,
    textTransform: null,
  },
  'bm-regular-italic': {
    fontSize: '16px',
    fontStyle: 'italic',
    fontWeight: '400',
    lineHeight: '22px',
    letterSpacing: null,
    textTransform: null,
  },
  'bs-bold': {
    fontSize: '14px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '20px',
    letterSpacing: null,
    textTransform: null,
  },
  'bs-semibold': {
    fontSize: '14px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '20px',
    letterSpacing: null,
    textTransform: null,
  },
  'bs-regular': {
    fontSize: '14px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: null,
    textTransform: null,
  },
  'bs-regular-italic': {
    fontSize: '14px',
    fontStyle: 'italic',
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: null,
    textTransform: null,
  },
  'bes-bold': {
    fontSize: '12px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '18px',
    letterSpacing: null,
    textTransform: null,
  },
  'bes-semibold': {
    fontSize: '12px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '18px',
    letterSpacing: null,
    textTransform: null,
  },
  'bes-regular': {
    fontSize: '12px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '18px',
    letterSpacing: null,
    textTransform: null,
  },
  'bes-regular-italic': {
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: '400',
    lineHeight: '18px',
    letterSpacing: null,
    textTransform: null,
  },
  'ol-bold': {
    fontSize: '12px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '16px',
    letterSpacing: null,
    textTransform: 'uppercase',
  },
  'ol-regular': {
    fontSize: '12px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '16px',
    letterSpacing: null,
    textTransform: 'uppercase',
  },
  'os-bold': {
    fontSize: '10px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '14px',
    letterSpacing: null,
    textTransform: 'uppercase',
  },
  'os-regular': {
    fontSize: '10px',
    fontStyle: null,
    fontWeight: '500',
    lineHeight: '14px',
    letterSpacing: null,
    textTransform: 'uppercase',
  },
  'c-regular': {
    fontSize: '12px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '16px',
    letterSpacing: null,
    textTransform: null,
  },
  'c-semibold': {
    fontSize: '12px',
    fontStyle: null,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: null,
    textTransform: null,
  },
  'c-bold': {
    fontSize: '12px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '16px',
    letterSpacing: null,
    textTransform: null,
  },
  'cs-regular': {
    fontSize: '10px',
    fontStyle: null,
    fontWeight: '400',
    lineHeight: '14px',
    letterSpacing: null,
    textTransform: null,
  },
  'cs-semibold': {
    fontSize: '10px',
    fontStyle: null,
    fontWeight: 500,
    lineHeight: '14px',
    letterSpacing: null,
    textTransform: null,
  },
  'cs-bold': {
    fontSize: '12px',
    fontStyle: null,
    fontWeight: '700',
    lineHeight: '14px',
    letterSpacing: null,
    textTransform: null,
  },
};
